import Advsblock from "./common/advsblock/advsblock";

function Advs(){
    return(
        <div className="centercolumn margin el">
            <h3>Преимущества проекта</h3>

            <div className="flexwrap">
                <Advsblock heading = "Доступный сервис вывоза пищевых отходов" desc = "Наш проект предоставляет бесплатную услугу вывоза пищевых отходов заведениям с ежедневным выбросом от 10 кг в день."/>
                <Advsblock heading = "Вклад в природу в «кликовой» доступности" desc = "Оформить бесплатную подписку на сервис вывоза отходов можно просто оставив заявку на нашем сайте. Так вы поспособствуете стремительному распространению сортировки и переработки органических отходов."/>
                <Advsblock heading = "Качественный продукт" desc = "В процессе переработки мы производим питательный компост, который фермеры, садоводы и владельцы АПК смогут использовать для огорода или больших плантаций."/>
                <Advsblock heading = "Получение eco-friendly статуса" desc = "Став нашим партнером, вы сможете закрепить за собой репутацию компании, предпринимающей активные действия в пользу экологии."/>
            </div>
        </div>
    )
}

export default Advs;